import { render, staticRenderFns } from "./InvestEdit.vue?vue&type=template&id=09271edb&"
import script from "./InvestEdit.vue?vue&type=script&lang=js&"
export * from "./InvestEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports